import styled from '@emotion/styled';
import { breakpoints, spacing } from '../../../../utils/styleguide';

const NAV_BAR_SIDE_PADDING = spacing[10];

const NavBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 ${spacing[3]}px;
  ${breakpoints.tablet} {
    padding: 0 ${NAV_BAR_SIDE_PADDING}px;
  }
`;

export default NavBarContainer;
